import { put } from '@/services/put'

export function refreshToken() {
  return put<undefined, { accessToken: string }>('/auth/refresh-token', undefined)
}
